__turbopack_context__.v({
  "icon": "CalendarTextField-module-scss-module__gxn62G__icon",
});
